import { useQuery } from "@tanstack/react-query";
import { __SHOW_COUNT_USER } from "request/configuration/__CountUser";

// Hook para obtener datos de usuario específico
export const useUserAccess = (token, userId, enabled = true) => {
  return useQuery({
    queryKey: ["userAccess", userId],
    queryFn: async () => {
      const res = await __SHOW_COUNT_USER(token, userId);
      
      if (res.data.status?.code === 403) {
        throw new Error(res?.data?.status?.message);
      }
      
      return res.data.status.data;
    },
    enabled: enabled && !!token && !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};
